export default {
  create () {
    return $('<div class="row" />')
  },

  getTools(row, apendedRowContent) {
    return [
      {title:'Add column', className: 'ge-add-column', iconClass: 'fa fa-plus-circle', eventHandlers: function () {
          row.append(apendedRowContent)
          row.click()
        }},
    ]
  },
}
